<script setup lang="ts">
import type { Agent, AgentOnList, AgentOnPreview } from '@@/shared/agent/types';

const props = defineProps<{
  agent: Agent | AgentOnList | AgentOnPreview
}>();

const IMG_WIDTH = 32;
const avatarUrl = useImageResize({
  width: IMG_WIDTH,
  src: toRef(() => props.agent.avatar.src),
});
</script>

<template>
  <div class="contents">
    <img
      loading="lazy"
      v-bind="avatarUrl"
      :width="IMG_WIDTH"
      :height="IMG_WIDTH"
      :alt="agent.fullName"
      :title="agent.fullName"
      class="rounded-full size-8 object-cover"
    >
  </div>
</template>
